import React from "react";

const VideoSkeleton = () => {
  return (
    <div className="w-full max-w-2xl mx-auto bg-gray-300 rounded-lg animate-pulse">
      {/* Video Player Skeleton */}
      <div className="w-full h-64 bg-gray-400 rounded-t-lg"></div>

      {/* Video Controls Skeleton */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center space-x-4">
          {/* Play/Pause Button */}
          <div className="w-10 h-10 bg-gray-500 rounded-full"></div>
          {/* Progress Bar */}
          <div className="w-3/4 bg-gray-500 h-2 rounded-full"></div>
        </div>
        <div className="flex items-center space-x-4">
          {/* Volume Button */}
          <div className="w-6 h-6 bg-gray-500 rounded-full"></div>
          {/* Fullscreen Button */}
          <div className="w-6 h-6 bg-gray-500 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default VideoSkeleton;
